<h2 mat-dialog-title>Lancer une analyse</h2>
<mat-dialog-content [formGroup]="form">
  <p class="hint">Plusieurs valeurs se séparent par des virgules. Les champs vides analysent toute la flotte.</p>
  <mat-form-field>
    <mat-label>Début</mat-label>
    <input matInput type="datetime-local" formControlName="windowStart" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Fin</mat-label>
    <input matInput type="datetime-local" formControlName="windowEnd" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Organisations (namespace)</mat-label>
    <input matInput formControlName="namespaces" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Bornes</mat-label>
    <input matInput formControlName="chargePointIds" placeholder="namespace/id" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Vendeurs</mat-label>
    <input matInput formControlName="vendors" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Modèles</mat-label>
    <input matInput formControlName="models" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Firmwares</mat-label>
    <input matInput formControlName="firmwareVersions" />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Annuler</button>
  <button mat-flat-button color="primary" type="button" (click)="submit()">Lancer</button>
</mat-dialog-actions>
